import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "tailwindcss/tailwind.css";

function CancelPlanPopup({ isOpen, setIsOpen, onConfirm }) {
  const openModal = () => {
    setIsOpen(true);
  };
  const { t } = useTranslation();

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <div className="p-4">
        {/* Modal background overlay */}
        {isOpen && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
            <div className="relative p-4 w-full max-w-xl">
              <div className="relative w-full bg-white rounded-lg shadow">
                <button
                  type="button"
                  onClick={closeModal}
                  className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>

                <div className="p-4 text-center">
                  <svg
                    className="mx-auto mb-4 text-gray-400 w-12 h-12"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <h3 className="mb-1 text-lg font-normal text-gray-500">
                    {/* Are you sure you want to cancel your subscription? */}
                    {t("component.cancel_plan_popup.cancel_msg1")}
                  </h3>
                  <p className="mb-5 text-md font-normal text-gray-500">
                    {t("component.cancel_plan_popup.cancel_msg2")}
                  </p>
                  <button
                    type="button"
                    onClick={onConfirm}
                    className="text-gray-500 bg-gray-200 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-gray-200 font-medium rounded-full text-sm inline-flex items-center px-5 py-2.5 me-2"
                  >
                    {t("component.cancel_plan_popup.yes_btn")}
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="text-white bg-[#f9593a] hover:bg-[#e34d33] focus:ring-4 focus:outline-none focus:ring-[#ffd1c9] rounded-full text-sm font-medium px-5 py-2.5"
                  >
                    {t("component.cancel_plan_popup.cancel_btn")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CancelPlanPopup;
